<div class="main-content" role="main">
  <!-- サブツールバー -->
  <mat-toolbar>
    <mat-toolbar-row>
      <button mat-icon-button class="header-icon">
        <mat-icon>star</mat-icon>
      </button>
      <span>
        <h2>Constellation</h2>
      </span>
      <ul>
        <li>
          <button mat-flat-button color="primary" (click)="drawLine()"  [attr.data-test]="'write-map'">
            星座を書く
          </button>
        </li>
      </ul>
      <ul>
        <li>
          <button mat-flat-button color="primary" (click)="saveMap()"  [attr.data-test]="'export-map'">
            星座を保存する
          </button>
        </li>
      </ul>
    </mat-toolbar-row>
  </mat-toolbar>
  <!-- 地図描画エリア -->
  <app-map></app-map>
  <router-outlet></router-outlet>
</div>
